import React from 'react';
import { Modal, Button } from '@clarke-energia/foton-v2';

import style from './style.module.css';

import powerTowerImage from 'src/assets/power-tower.svg';

interface IndicationModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

const IndicationModal: React.FC<IndicationModalProps> = ({ isOpen, setIsOpen }) => {
  return (
    <Modal isOpen={isOpen} setOpen={setIsOpen} className={style.modal} title={{ text: '', extraClassName: 'hidden' }}>
      <div className={style.content}>
        <img src={powerTowerImage} alt="Ícone de torre" className={style.image} />

        <h2 className={style.title}>
          Ganhe <span className={style.highlight}>mensalidade grátis</span>!
        </h2>

        <p className={style.paragraph}>
          Participe do &apos;Clarke em Rede&apos;! A cada indicação que se tornar cliente Clarke, você ganhará 100% de
          desconto em um mês de gestão.
        </p>
        <p className={style.paragraph}>
          Para participar é fácil: basta enviar o contato de quem você deseja indicar ao seu gestor ou acessar o link
          abaixo.
        </p>

        <Button
          kind="primary"
          className={style.ctaButton}
          onClick={() => {
            setIsOpen(false);
            window.open('https://lp.clarke.com.br/clarke-em-rede', '_blank');
          }}
        >
          Quero saber mais
        </Button>
      </div>
    </Modal>
  );
};

export default IndicationModal;
